import React from "react";
import { motion } from "framer-motion";
import {
  FiCode,
  FiServer,
  FiSmartphone,
  FiDatabase,
  FiCloud,
  FiGitBranch,
  FiBarChart2,
  FiCpu,
} from "react-icons/fi";

function TechnologyStack() {
  const techStack = [
    { title: "Programming Languages", items: ["C/C++", "Java", "JavaScript", "Python", "PHP"], icon: <FiCode /> },
    { title: "Web Development", items: ["Frontend", "Backend"], icon: <FiServer /> },
    { title: "Mobile App Development", items: ["Flutter", "React Native", "Swift (iOS)"], icon: <FiSmartphone /> },
    { title: "Databases", items: ["Relational Database", "NoSQL Database"], icon: <FiDatabase /> },
    { title: "Cloud Platforms", items: ["AWS", "Microsoft Azure", "Google Cloud Platform"], icon: <FiCloud /> },
    { title: "DevOps", items: ["GitHub Actions", "Docker", "Kubernetes"], icon: <FiGitBranch /> },
    { title: "Data Analytics", items: ["Tableau", "Power BI", "SQL", "MS Excel", "Statistics"], icon: <FiBarChart2 /> },
    { title: "Machine Learning", items: ["Machine Learning Algorithms"], icon: <FiCpu /> },
  ];

  return (
    <div className="w-full font-sans">

      {/* Hero Section */}
      <section className="relative w-full py-32 bg-gradient-to-b from-black via-gray-900 to-black text-center px-6">
        <motion.h2
          className="text-5xl md:text-6xl font-extrabold text-white mb-6 tracking-tight"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Our <span className="text-[#df2313]">Technology</span> Stack
        </motion.h2>

        <motion.p
          className="text-gray-300 text-lg md:text-xl max-w-3xl mx-auto mb-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Cutting-edge tools and frameworks powering fast, secure, and scalable solutions.
        </motion.p>

        {/* Scroll Arrow */}
        <button
          onClick={() => {
            const section = document.getElementById("tech-cards-section");
            if (section) section.scrollIntoView({ behavior: "smooth" });
          }}
          className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce bg-[#df2313] w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-8 w-8 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={3} // Makes the arrow thicker
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

      </section>

      {/* Cards Section */}
      <section id="tech-cards-section" className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {techStack.map((tech, idx) => (
            <motion.div
              key={idx}
              className="relative flex flex-col items-start gap-4 p-8 rounded-3xl bg-white shadow-2xl hover:shadow-3xl transition-transform transform hover:-translate-y-3 hover:scale-105 cursor-pointer"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
            >
              {/* Icon Circle */}
              <motion.div
                className="flex-shrink-0 w-16 h-16 rounded-full bg-gradient-to-br from-[#df2313] to-[#f76c6c] flex items-center justify-center text-white text-2xl shadow-xl mb-3"
                whileHover={{ rotate: 15 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                {tech.icon}
              </motion.div>

              {/* Text */}
              <div>
                <h3 className="text-xl md:text-2xl font-bold mb-2 text-gray-900">{tech.title}</h3>
                <ul className="mt-1 text-gray-600 text-sm md:text-base space-y-1">
                  {tech.items.map((item, i) => (
                    <li key={i} className="hover:text-[#df2313] transition-colors duration-300">{item}</li>
                  ))}
                </ul>
              </div>

            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default TechnologyStack;
